import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { useSearchParams } from "@/helpers/useSearchParams";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";

import DeviceList from "./DeviceList";

const AlarmDeviceList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { alarmPolicyOptionId, triggerStatus } = useSearchParams();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "报警管理" })} />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "报警管理" })}
        </Typography>
      </div>
      <div className={classes.paperWrapper}>
        <DeviceList
          alarmPolicyOptionId={alarmPolicyOptionId}
          triggerStatus={triggerStatus}
        />
      </div>
    </>
  );
};

export default AlarmDeviceList;
